import { supportServiceConnectClient } from "api";

import {
  CreateSatelliteDeviceRequest,
  DeleteSatelliteDeviceRequest,
  GetSatelliteDevicesRequest,
  GetSatelliteDevicesResponse,
  UpdateSatelliteDeviceRequest,
} from "@safetyculture/s12-apis-connect-web/s12/loneworker/admin/v1/admin_satellites_service_pb";
import {
  GetEscalationGroupsRequest,
  GetEscalationGroupsResponse,
  GetOrgSettingsRequest,
  GetOrgSettingsResponse,
  UpdateOrgSettingsRequest,
  UpdateOrgSettingsResponse,
} from "@safetyculture/s12-apis-connect-web/s12/loneworker/admin/v1/admin_service_pb";
import { MonitoringCompany } from "@safetyculture/s12-apis-connect-web/s12/loneworker/v1/monitoring_pb";
import { SatelliteDeviceModel } from "@safetyculture/s12-apis-connect-web/s12/loneworker/v1/satellite_pb";

import { RequestMetadata } from "api/types";
import { toUUID } from "helpers/s12-helpers";

export const getLoneworkerOrgSettings = async (
  orgId: string,
  headers: Record<RequestMetadata, string>,
): Promise<GetOrgSettingsResponse> => {
  const req = new GetOrgSettingsRequest({ orgId: toUUID(orgId) });
  return supportServiceConnectClient.getLoneworkerOrgSettings(req, { headers });
};

export const updateLoneworkerOrgSettings = async (
  orgId: string,
  monitoringSeatsTotal: number,
  monitoringCompany: MonitoringCompany,
  headers: Record<RequestMetadata, string>,
): Promise<UpdateOrgSettingsResponse> => {
  const req = new UpdateOrgSettingsRequest({
    orgId: toUUID(orgId),
    monitoringSeatsTotal,
    monitoringCompany,
  });
  return supportServiceConnectClient.updateLoneworkerOrgSettings(req, {
    headers,
  });
};

export const getLoneworkerEscalationGroups = async (
  orgId: string,
  headers: Record<RequestMetadata, string>,
): Promise<GetEscalationGroupsResponse> => {
  const req = new GetEscalationGroupsRequest({ orgId: toUUID(orgId) });
  return supportServiceConnectClient.getLoneworkerEscalationGroups(req, {
    headers,
  });
};

export const getSatelliteDevicesByOrgId = async (
  orgId: string,
  pageToken: string,
  search: string,
  headers: Record<RequestMetadata, string>,
): Promise<GetSatelliteDevicesResponse> => {
  const req = new GetSatelliteDevicesRequest({
    pageSize: 10,
    pageToken,
    filter: {
      orgIds: [toUUID(orgId)],
      search,
    },
  });
  return supportServiceConnectClient.getSatelliteDevices(req, {
    headers,
  });
};

export const createSatelliteDevice = async (
  orgId: string,
  serialNumber: string,
  model: SatelliteDeviceModel,
  notes: string,
  headers: Record<RequestMetadata, string>,
) => {
  const req = new CreateSatelliteDeviceRequest({
    orgId: toUUID(orgId),
    serialNumber,
    model,
    notes,
  });
  return supportServiceConnectClient.createSatelliteDevice(req, {
    headers,
  });
};

export const updateSatelliteDevice = async (
  id: string,
  notes: string,
  headers: Record<RequestMetadata, string>,
) => {
  const req = new UpdateSatelliteDeviceRequest({
    id,
    notes,
  });
  return supportServiceConnectClient.updateSatelliteDevice(req, {
    headers,
  });
};

export const deleteSatelliteDevice = async (
  id: string,
  headers: Record<RequestMetadata, string>,
) => {
  const req = new DeleteSatelliteDeviceRequest({
    id,
  });
  return supportServiceConnectClient.deleteSatelliteDevice(req, {
    headers,
  });
};
